import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from 'src/@/components/ui/sheet';
import { Input } from 'src/@/components/ui/input';
import { LoadingButton } from 'src/@/components/ui/loading-button';
import v2_actionCriarPipeline from 'src/actions/v2/cliente/v2_actionCriarPipeline';
import v2_actionEditarPipeline from 'src/actions/v2/crm/v2_actionEditarPipeline';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function DrawerNovoFunil({
  user,
  cliente,
  open,
  isEdit,
  pipelineId,
  onClose,
  onCallback,
  pipeline,
}) {
  const { t } = useTranslation('settings');
  const [loading, setLoading] = useState(false);
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');

  async function handleCriarFunil() {
    try {
      setLoading(true);
      const result = await v2_actionCriarPipeline(cliente._id, {
        scope: {
          nome,
          descricao,
          criadoPor: user._id,
        },
      });
      if (result.data.data) {
        onCallback();
        onClose();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function handleEditarPipilene(id, scope) {
    try {
      setLoading(true);
      await v2_actionEditarPipeline(id, {
        action: 'editar_pipeline',
        scope,
      }, cliente._id);
      onCallback();
      onClose();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  function handleOnClose() {
    onClose();
    setNome('');
    setDescricao('');
  }

  useEffect(() => {
    if (isEdit && pipeline) {
      setNome(pipeline.pipeline_nome || '');
      setDescricao(pipeline.description || '');
    } else if (!open) {
      setNome('');
      setDescricao('');
    }
  }, [pipeline, isEdit, open]);

  return (
    <Sheet open={open} onOpenChange={(isOpen) => !isOpen && handleOnClose()}>
      <SheetContent className={D.sheetContent} style={{ fontFamily: D.fontStack }}>
        <SheetHeader className={`${D.sheetHeader} text-left space-y-0`}>
          <SheetTitle className={D.dialogTitle}>
            {isEdit
              ? t('funnel.core.newFunnelDrawer.editTitle', 'Editar Funil')
              : t('funnel.core.newFunnelDrawer.createTitle', 'Criar Funil')}
          </SheetTitle>
          <p className={`${D.dialogDesc} mt-1.5`}>
            {isEdit
              ? t('funnel.core.newFunnelDrawer.editSubtitle', 'Altere o nome ou a descrição deste funil.')
              : t('funnel.core.newFunnelDrawer.createSubtitle', 'Defina o nome do funil. Os estágios você adiciona depois.')}
          </p>
        </SheetHeader>

        <div className={D.sheetBody}>
          <div className={D.field}>
            <label htmlFor="nome" className={D.label}>
              {t('labels.name', { ns: 'common' })}
            </label>
            <Input
              id="nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              placeholder={t('funnel.core.newFunnelDrawer.namePlaceholder', 'Ex: Comercial')}
              className={D.input}
            />
            <p className={D.hint}>
              {t('funnel.core.newFunnelDrawer.nameHint', 'Nome interno, visível só para a sua equipe.')}
            </p>
          </div>
          <div className={D.field}>
            <label htmlFor="descricao" className={D.label}>
              {t('labels.description', { ns: 'common' })}
            </label>
            <Input
              id="descricao"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder={t('funnel.core.newFunnelDrawer.descriptionPlaceholder', 'Ex: Funil de vendas principal')}
              className={D.input}
            />
            <p className={D.hint}>
              {t('funnel.core.newFunnelDrawer.descriptionHint', 'Opcional. Ajuda a equipe a saber para que serve este funil.')}
            </p>
          </div>
        </div>

        <div className={D.sheetFooter}>
          <button type="button" className={D.ghostButton} onClick={handleOnClose}>
            {t('buttons.cancel', { ns: 'common' })}
          </button>
          <LoadingButton
            loading={loading}
            onClick={() => {
              if (isEdit) {
                handleEditarPipilene(pipelineId, { nome, description: descricao });
              } else {
                handleCriarFunil();
              }
            }}
            className={D.primaryButton}
          >
            {isEdit
              ? t('funnel.core.newFunnelDrawer.saveChangesButton', 'Salvar alterações')
              : t('funnel.core.newFunnelDrawer.createTitle', 'Criar Funil')}
          </LoadingButton>
        </div>
      </SheetContent>
    </Sheet>
  );
}
